<template>
  <InlineSvg
    v-if="iconPath"
    :src="iconPath"
    width="1em"
    height="1em"
    class="uc-svg-icon"
  />
</template>

<script setup>
// @ts-check
import { ref, watchEffect } from 'vue';
import InlineSvg from 'vue-inline-svg';

/** @import { Ref } from 'vue' */

const props = defineProps({
  name: { type: String, default: null },
});

/** @type {Ref<string | null>} */
const iconPath = ref(null);

const context = import.meta.webpackContext('@/static/icons');

async function loadIcon() {
  try {
    if (props.name) {
      const path = await context(`./${props.name}.svg`);
      if (path) {
        iconPath.value = /** @type {string} */ (path);
      }
    } else {
      iconPath.value = null;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    iconPath.value = null;
  }
}

watchEffect(loadIcon);
</script>
